<template>
  <div key="crops">
    <p class="heading">Cropping Profile</p>

    <v-expansion-panels
      class="expand"
      v-for="(locations, index) in locations"
      :key="index"
    >
      <v-expansion-panel
        style="margin-top: 0rem; border: none !important; margin-bottom: 4px"
      >
        <v-expansion-panel-header style="height: 40px">
          <div style="display: flex; align-items: end">
            <question-tab showDropdownQuestion="true" :heading="crops.crop_type" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <multiple-button type="crops" :data="crops" />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import questionTab from "./question.vue";
import multipleAnswers from "./multiple-answer.vue";
import multipleButton from "./multiple-button.vue";
import API_URL from "../../../../helpers/apiUrls";
export default {
  name: "cropTab",
  data() {
    return {
      locations: [],
    };
  },
  mounted() {
    this.getStateList();
    
  },
  comments:{
    "question-tab": questionTab,
    "multiple-answer": multipleAnswers,
    "multiple-button": multipleButton,
  },
  methods:{
    getStateList() {
      const successHandler = (response) => {
        if (response.status === 200) {
          this.locations = response.data.results;
        }
      };

      const errorHandler = (response) => {
        this.showToast("Something went wrong internally!", "error", 10000);
      };

      this.requestGET(
        `${API_URL.crops}`,
        {},
        {},
        successHandler,
        errorHandler
      );
    },
  }
};
</script>
<style lang="stylus" scoped></style>
